import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex/icons';
import OfferEndingText from './OfferEndingText.js';
import { getTranslation } from '../../translations/translations.js';

const Offer = styled.span`
  display: inline-block;
  position: relative;
  color: #e37a00;
`;

const MoreDetails = styled.li`
  padding-left: 0;
  margin-bottom: 0;
  color: #e37a00;
  text-align: center;

  &:before {
    display: none;
  }
`;

const IconDeals = styled(Icon)`
  color: #e37a00;
  line-height: 1em;

  svg {
    height: 1em;
  }
`;

const ProductOffers = styled.ul`
  list-style: none;
  background-color: #fefaf1;
  border: solid 1px #ee9022;
  border-radius: 3px;
  font-size: 13px;
  margin-bottom: 10px;

  li {
    margin-bottom: 0;
  }
`;

const ProductOffersList = styled(ProductOffers)`
  padding: 8px;

  ${Offer} {
    margin-bottom: 10px;
    margin-left: 1.5em;
    text-align: left;
  }

  ${IconDeals} {
    left: -1.5em;
    position: absolute;
  }
`;

const ProductOffersGrid = styled(ProductOffers)`
  padding: 5px;
`;

const AVM_MAX = 1;

function futureDate() {
  return new Date().setDate(new Date().getDate() + 7);
}

class AddedValueMessagesListing extends PureComponent {
  render() {
    let listView;
    const { props } = this;
    const offers = props.data;
    const visibleOffers = [];

    for (let i = 0; i < offers.length; i++) {
      if (offers[i].show) visibleOffers.push(offers[i]);
    }

    if (props.view === 'grid') {
      listView = (
        <li>
          <Offer className={'offer'}>
            <IconDeals icon={'Deals'} />
            {' '}
            {offers.length}
            {' '}
            {offers.length > 1
              ? getTranslation('dealsAvailable') : getTranslation('onedealAvailable')}
          </Offer>
        </li>
      );
    } else if (visibleOffers) {
      listView = (
        visibleOffers
          .slice(0, AVM_MAX)
          .map((avm, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={i}>
              <Offer className={'offer'}>
                <IconDeals icon={'Deals'} />
                {avm.title}
              </Offer>
              {new Date(avm.to) < futureDate() &&
              <OfferEndingText from={avm.from} to={avm.to} />}
            </li>
          ))
      );
    }

    const renderContent = () => (
      <>
        {listView}
        {props.view === 'list' && offers.length > 1 && (
        <MoreDetails className={'more-deals'}>
          {
          offers.length === 2
            ? `+ ${getTranslation('moreDealSingle')}`
            : `+ ${offers.length - 1} ${getTranslation('moreDealsMulti')}`
        }
        </MoreDetails>
        )}
      </>
    );

    if (visibleOffers.length >= 1) {
      if (props.view === 'list') {
        return (
          <ProductOffersList className={`product-offers product-offers-${props.view}`}>{renderContent()}</ProductOffersList>
        );
      }
      if (props.view === 'grid') {
        return (
          <ProductOffersGrid className={`product-offers product-offers-${props.view}`}>{renderContent()}</ProductOffersGrid>
        );
      }
    } if (offers.length >= 1 && props.view === 'grid') {
      return (
        <ProductOffersGrid className={' product-offers product-offers-grid'}>
          {listView}
        </ProductOffersGrid>
      );
    }
    return null;
  }
}

AddedValueMessagesListing.propTypes = {
  view: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      from: PropTypes.string,
      to: PropTypes.string,
      show: PropTypes.bool
    })
  ).isRequired
};

AddedValueMessagesListing.displayName = 'AddedValueMessagesListing';

export default AddedValueMessagesListing;
